import type { LibraryObjectResponse } from '../types/api';
import { resolveAssetUrl } from './api';

export function mapLibraryObjectResponses(
  items: LibraryObjectResponse[],
  _userId?: string | null,
  _movieId?: number | null
) {
  return items.map((item) => {
    const src = item.url
      ? resolveAssetUrl(item.url)
      : item.fullPath
        ? resolveAssetUrl(item.fullPath)
        : '';
    const thumbnail = item.thumbnailUrl
      ? resolveAssetUrl(item.thumbnailUrl)
      : undefined;

    return {
      id: String(item.id),
      name: item.name,
      type: item.type as 'image' | 'clip',
      src,
      thumbnail,
    };
  });
}
